import { render, staticRenderFns } from "./Side.vue?vue&type=template&id=a6dbc990&scoped=true"
var script = {}
import style0 from "./Side.vue?vue&type=style&index=0&id=a6dbc990&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6dbc990",
  null
  
)

export default component.exports